import { render, staticRenderFns } from "./DictSelectWithAdd.vue?vue&type=template&id=205a95fa&scoped=true"
import script from "./DictSelectWithAdd.vue?vue&type=script&lang=js"
export * from "./DictSelectWithAdd.vue?vue&type=script&lang=js"
import style0 from "./DictSelectWithAdd.vue?vue&type=style&index=0&id=205a95fa&prod&scoped=true&lang=css"
import style1 from "./DictSelectWithAdd.vue?vue&type=style&index=1&id=205a95fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a95fa",
  null
  
)

export default component.exports